import { useEffect, useState } from "react";
import { getAllAnswerValues } from "@formsort/custom-question-api";
import * as Sentry from "@sentry/react";
import type { z } from "zod";

export const useFlowAnswer = <T>(answerId: string, schema: z.ZodType<T>): T | undefined => {
  const [data, setData] = useState<T>();

  useEffect(() => {
    getAllAnswerValues().then((answers) => {
      if (!answers || !answers[answerId]) {
        return;
      }
      const result = schema.safeParse(answers[answerId]);
      if (result.success) {
        setData(result.data);
      } else {
        Sentry.captureException(result.error, { extra: { answerId } });
      }
    });
  }, [answerId, schema]);

  return data;
};
